import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 126px;
  padding: 24px 16px;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  &:hover {
    background-color: ${({ theme }) => theme.colors.black2};
    transition: background-color 0.3s ease;
  }
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 64px;
  height: 64px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
